import moment from 'moment';

let validatePhone = (phoneNumber) => {
  var phonePattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3}) ?[-. ]? ?([0-9]{4})$/;
  if (phoneNumber.match(phonePattern)) return null;
  else return 'Enter a valid phone number.';
}

let validateEmail = (email) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(email)) return null;
    else return 'Enter a valid email address';
}

let validateNumber = (value, placeholder) => {
  if (isNaN(value) === false && value !== '') return null;
  else return placeholder + ' must be a valid number';
}

let validateColor = (value, placeholder) => {
  if (/^#[0-9A-F]{6}$/i.test(value)) return null
  else return placeholder + ' must be a valid hex color ex. #FFFFFF';
}

let validateImage = (value, placeholder) => {
  if (value && value != '') return null;
  else return placeholder + ' cannot be blank';
}

let validatePin = (pin) => {
  if (isNaN(pin) === false && pin.length >= 2) return null;
  else return 'Pin must be at least 2 numbers';
}

let validateDefault = (value, fieldName) => {
    if (value !== '') return null;
    else return 'Enter a valid ' + fieldName;
}

let validateSelect = (value, fieldName) => {
    if (value !== '') return null;
    else return 'Select a valid ' + fieldName;
}

let validatePoints = (value, placeholder) => {
  if (isNaN(value) === false && value !== '' && value > 0) return null;
  else return placeholder + ' must be a valid number greater than 0';
};

let validatePasswordConfirmation = (pass, pass_conf) => {
  if (pass === pass_conf) return null;
  else return 'Passwords do not match';
}

let validateLength = (value, charLimit) => {
  if (value.length < charLimit) return null;
  else return `Must be less than ${charLimit} characters`;
}

let validatePassword = (pass) => {
  let hasErrors = null;
  let password_criteria = {
    prompt: "Your password must have:",
    errors: [
      {
        requirement: '8 to 15 characters',
        valid: false
      },
      {
        requirement: '1 number or special character',
        valid: false
      },
      {
        requirement: '1 lowercase letter',
        valid: false
      },
      {
        requirement: '1 uppercase letter',
        valid: false
      }
    ]
  }

  if (pass.length > 7 && pass.length < 16) password_criteria.errors[0].valid = true;
  else hasErrors = true;
  if (/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(pass) || pass.match(/\d+/g) != null)
      password_criteria.errors[1].valid = true;
  else hasErrors = true;
  if (/[a-z]/.test(pass)) password_criteria.errors[2].valid = true;
  else hasErrors = true;
  if (/[A-Z]/.test(pass)) password_criteria.errors[3].valid = true;
  else hasErrors = true;
  return { password_criteria: password_criteria, error: hasErrors }
}

let hasMultiErrors = (errors) => {
  let hasErrors = false;
  for (let i = 0; i < errors.length; i++) {
    if (errors[i].valid === false) {
      hasErrors = true;
      break;
    }
  }
  return hasErrors
}

let validateDateTime = (date, time, key) => {
  if(!date || !time) {
    console.log('Missing field...')
    return;
  }

  const dayMoment = moment(date, 'MM/DD/YY').startOf('day');
  const timeToValidate = dayMoment.add(time.hours(), 'hours').add(time.minutes(), 'minutes');
  const now = moment();
  
  if(now.isAfter(timeToValidate)) {
    return `The ${key === 'date_from' ? 'day' : 'time' } you selected is in the past!`;
  }

  return null;
}

export const checkForErrors = (phase) => {
  let hasErrors = false;
  Object.keys(phase).forEach(key => {
    if (phase[key].error !== null && typeof(phase[key].error) !== 'object'
      && phase[key].isRequired === true) {
      hasErrors = true;
    } else if (phase[key].error && phase[key].error.errors && hasMultiErrors(phase[key].error.errors)) {
      hasErrors = true;
    } else if (phase[key].touched === false && phase[key].isRequired == true) {
      hasErrors = true;
    }
  })
  return hasErrors;
}

export const validatePhases = (data) => {
  Object.keys(data).forEach(key => {
    let { validationType, value, isRequired, breed, placeholder } = data[key];
    if (validationType && validationType === 'email') {
      data[key].error = validateEmail(value);
    } else if (validationType && validationType === 'color') {
      data[key].error = validateColor(value, placeholder);
    } else if (validationType && validationType === 'image') {
      data[key].error = validateImage(data[key].fileName, placeholder);
    } else if (validationType && validationType === 'number') {
      data[key].error = validateNumber(value, placeholder);
    } else if (validationType && validationType === 'phone') {
      data[key].error = validatePhone(value, placeholder);
    } else if (validationType && validationType === 'password') {
      let passwordErrors = validatePassword(value);
      data[key].error = passwordErrors.error;
      data[key].multiError = passwordErrors.password_criteria;
    } else if (validationType && validationType === 'pin') {
      data[key].error = validatePin(value);
    } else if (validationType && validationType === 'password_confirm') {
      data[key].error = validatePasswordConfirmation(value, data['password'].value);
    } else if (breed === 'textarea' && validationType === 'length') {
      data[key].error = validateLength(value, data[key].charLimit);
    } else if ((isRequired === true && breed === 'input') || breed === 'textarea') {
      data[key].error = validateDefault(value, placeholder);
    } else if (isRequired === true && breed === 'select') {
      data[key].error = validateSelect(value, placeholder);
    } else if (isRequired === true && breed === 'points') {
      data[key].error = validatePoints(value, placeholder);
    } else if (validationType && validationType === 'isNotInPast') {
      data[key].error = validateDateTime(data['date_from'].value, data['start_time'].value, key);
    }
    data[key].isActive = false
  })

  return data
}



/** WEBPACK FOOTER **
 ** ./src/helpers/Validation.js
 **/